// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import mainFeature from './js/widgets/mainFeature.js';
import slideshow from './js/widgets/slideshow.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import masonryCardsDouble from './js/widgets/masonryCardsDouble.js';
import seoWidget from './js/widgets/seoWidget.js';
import * as facebookFeed from './js/widgets/facebookFeed';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(globalThis).ready(function () {
  customTicketButton();
  if (window.location.pathname === '/') {
    mainFeature();
    slideshow();
    multiScheduleFeature();
    masonryCardsDouble('masonryCardsDoubleLarge', masonryCardsDoubleLargeOpts, 2);
    masonryCardsDouble('masonryCardsDoubleSmall', masonryCardsDoubleSmallOpts, 4);
    seoWidget();
    scrollerSponsors();
    $(globalThis).load(function () {
      facebookFeed.facebookfeed(true);
    });
  }
});
